// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"efaf93a4","599":"38bd1a05","631":"48b6041f","653":"2f9644be","731":"efcff22c","975":"90324cc2"}[chunkId] + ".chunk.js";
};